/**
 * Bootstrap JS is loaded once in vendor.bundle.js (vendor-setup.ts → window.bootstrap).
 * nais.bundle.js must not import bootstrap runtime modules — each copy registers
 * its own data-api handlers on document (e.g. collapse toggle fires twice).
 */
import type { Dropdown, Modal, Tab, Tooltip } from 'bootstrap';

type BootstrapNamespace = {
    Tooltip: typeof Tooltip;
    Dropdown: typeof Dropdown;
    Modal: typeof Modal;
    Tab: typeof Tab;
};

function getBootstrap(): BootstrapNamespace {
    const api = window.bootstrap as BootstrapNamespace | undefined;
    if (!api?.Tooltip || !api?.Dropdown || !api?.Modal || !api?.Tab) {
        throw new Error(
            'window.bootstrap is not loaded. Ensure vendor.bundle.js loads before nais.bundle.js.',
        );
    }

    return api;
}

export function getBootstrapTooltip(): typeof Tooltip {
    return getBootstrap().Tooltip;
}

export function getBootstrapDropdown(): typeof Dropdown {
    return getBootstrap().Dropdown;
}

export function getBootstrapModal(): typeof Modal {
    return getBootstrap().Modal;
}

export function getBootstrapTab(): typeof Tab {
    return getBootstrap().Tab;
}
